module.exports = __webpack_public_path__ + "img/process.1e2f0d22.png";